import { getOrElse } from 'fp-ts/lib/Option';
import {
  StyledOverline,
  StyledUserMovementCard,
  StyledOverviewMetrics,
  StyledCaptionSecondary,
  StyledSubtitle,
  StyledMetric,
  StyledMetricRow,
  StyledHeading,
} from 'modules/intelligentInsights/brandAffinityInsights/components/breakdownByAffinity/cohortTabContent/common.styles';
import {
  CAME_FROM,
  EXIST_PROJECT,
  formatOneDecimalPlaceOption,
  NEW,
  NEW_TO_PROJECT,
  RETAINED,
  USER_MOVEMENT,
  USERS,
  USERS_MOVED,
  USERS_STAYED,
  USERS_WHO_LEFT,
} from 'modules/intelligentInsights/brandAffinityInsights/constants';
import {
  useBrandAffinityTranslation,
  BRAND_AFFINITY_NAMES_TO_I18N_KEYS,
  BrandAffinityLevel,
} from 'modules/domains';
import { localizeCompactNumber } from 'utils/l10n';
import { useCoreContext } from 'modules/intelligentInsights/brandAffinityInsights/contexts/core/CoreContext';
import { MovementLegend } from 'modules/intelligentInsights/brandAffinityInsights/components/breakdownByAffinity/cohortTabContent/aboutYourCohortUsersCards/MovementLegend';
import {
  defaultCalculateMovementMetrics,
  useDataManagementContext,
} from 'modules/intelligentInsights/brandAffinityInsights/contexts/dataManagement/DataManagementContext';
import { MovementDivider } from 'modules/intelligentInsights/brandAffinityInsights/components/breakdownByAffinity/cohortTabContent/aboutYourCohortUsersCards/UserMovementCard.styles';

export const UserMovementCard = () => {
  const { t } = useBrandAffinityTranslation();
  const { selectedAffinityTab } = useCoreContext();
  const { managedInsightsData } = useDataManagementContext();
  const calculatedMovementData = getOrElse(() => defaultCalculateMovementMetrics)(
    managedInsightsData.calculatedMovementMetrics,
  );

  const cohortMovement = calculatedMovementData.filter(
    (data) => data.cohort === selectedAffinityTab,
  )[0];

  const translatedLevel = t(BRAND_AFFINITY_NAMES_TO_I18N_KEYS[selectedAffinityTab]);

  return (
    <StyledUserMovementCard>
      <StyledOverline>{USER_MOVEMENT}</StyledOverline>
      <StyledOverviewMetrics>
        <StyledMetricRow>
          <StyledMetric>
            <StyledSubtitle>{`${NEW} ${translatedLevel} ${USERS}`}</StyledSubtitle>
            <StyledCaptionSecondary>{`${
              selectedAffinityTab === BrandAffinityLevel.UNSCORED ? NEW_TO_PROJECT : EXIST_PROJECT
            } ${translatedLevel} ${CAME_FROM}`}</StyledCaptionSecondary>
          </StyledMetric>
          <StyledHeading>
            {localizeCompactNumber(
              cohortMovement.totalNewUsers,
              undefined,
              formatOneDecimalPlaceOption,
            )}
          </StyledHeading>
        </StyledMetricRow>
        <MovementLegend legendType="newUsersCohort" />
        <MovementDivider />
        <StyledMetricRow>
          <StyledMetric>
            <StyledSubtitle>{`${RETAINED} ${USERS}`}</StyledSubtitle>
            <StyledCaptionSecondary>{`${USERS_STAYED} ${translatedLevel}`} </StyledCaptionSecondary>
          </StyledMetric>
          <StyledHeading>
            {localizeCompactNumber(
              cohortMovement.totalRetainedUsers,
              undefined,
              formatOneDecimalPlaceOption,
            )}
          </StyledHeading>
        </StyledMetricRow>
        <MovementDivider />
        <StyledMetricRow>
          <StyledMetric>
            <StyledSubtitle>{USERS_WHO_LEFT}</StyledSubtitle>
            <StyledCaptionSecondary>{USERS_MOVED}</StyledCaptionSecondary>
          </StyledMetric>
          <StyledHeading>
            {localizeCompactNumber(
              cohortMovement.totalUsersLeft,
              undefined,
              formatOneDecimalPlaceOption,
            )}
          </StyledHeading>
        </StyledMetricRow>
        <MovementLegend legendType="usersLeftCohort" />
      </StyledOverviewMetrics>
    </StyledUserMovementCard>
  );
};
